module.exports = __webpack_public_path__ + "img/move18.a660c22a.jpg";